/**
 * Judge.me Review Text Translations
 */

document.addEventListener('DOMContentLoaded', function() {
  try {

    const currentLocale = (window.Shopify && window.Shopify.locale) || 
                         document.documentElement.lang || 
                         'tr';

    const translations = {
      'tr': {
        'Derecelendirme': '',
        'Değerlendirme içeriği': 'Nurus deneyiminizi bizlerle paylaşır mısınız?',
        'Buraya yazmaya başlayın...': '',
        'Değerlendirme Gönder': 'Paylaş',
        'Write a review': 'Yorum yapın',
        'Based on': 'Toplam',
        'review': 'yorum',
        'reviews': 'yorum',
        'upload_image': 'Fotoğraf yükle',
        'write_review': 'Yorum yapın',
        'review_count': 'Toplam',
        'review_count_plural': 'yorum',
        'accessibility': {
          'close': 'Kapat'
        }
      }
    };

    const localeTranslations = translations[currentLocale] || translations['tr'];

    const getLocaleText = (key) => {
      const keys = key.split('.');
      let value = localeTranslations;
      
      for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
          value = value[k];
        } else {
          return key; 
        }
      }
      
      return value || key;
    };

    const isMobile = () => {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
             window.innerWidth <= 768 ||
             ('ontouchstart' in window);
    };

    const debounce = (func, wait) => {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };


    function replaceTextContent() {
      const spinners = document.querySelectorAll('.jdgm-spinner');
      spinners.forEach(spinner => {
        spinner.style.display = 'none';
      });

      const judgeWidgets = document.querySelectorAll('[class*="jdgm"]');
      if (judgeWidgets.length === 0) {
        setTimeout(replaceTextContent, 500);
        return;
      }

      hideUnwantedElements();
      replaceReviewCountTexts();

      Object.keys(localeTranslations).forEach(originalText => {
        const translatedText = localeTranslations[originalText];
        
        if (originalText === translatedText) return;

        const elements = document.querySelectorAll('*');
        elements.forEach(element => {
          if (element.childNodes) {
            element.childNodes.forEach(node => {
              if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === originalText) {
                node.textContent = translatedText;
              }
            });
          }

          if (element.placeholder === originalText) {
            element.placeholder = translatedText;
          }

          if (element.value === originalText) {
            element.value = translatedText;
          }

          if (element.getAttribute('aria-label') === originalText) {
            element.setAttribute('aria-label', translatedText);
          }
        });
      });
    }

    function replaceReviewCountTexts() {
      const elements = document.querySelectorAll('*');
      elements.forEach(element => {
        if (element.childNodes) {
          element.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
              const text = node.textContent.trim();
              
              // Pattern variations: "Based on X review(s)" -> "Toplam X yorum"
              const patterns = [
                /^Based on (\d+) reviews?$/i,
                /^(\d+) reviews?$/i,
                /^Based on (\d+)$/i,
                /^(\d+) review$/i
              ];
              
              for (const pattern of patterns) {
                const match = text.match(pattern);
                if (match) {
                  const reviewCount = match[1];
                  node.textContent = `${getLocaleText('review_count')} ${reviewCount} ${getLocaleText('review_count_plural')}`;
                  break;
                }
              }
            }
          });
        }
      });
    }

    function updateRealAverage() {
      try {
        const summaryContainers = document.querySelectorAll('[aria-label*="Average rating is"], [aria-label*="rating is"]');
        
        summaryContainers.forEach(container => {
          const ariaLabel = container.getAttribute('aria-label');
          if (ariaLabel) {
            const ratingMatch = ariaLabel.match(/rating is (\d+(?:\.\d+)?)/i);
            if (ratingMatch) {
              const rating = parseFloat(ratingMatch[1]);
              const formattedRating = rating.toFixed(1).replace('.', ',');
              
              const averageSpan = container.querySelector('.jdgm-all-reviews__summary-average, .jdgm-rev-widg__summary-average, .jdgm-summary-average');
              if (averageSpan) {
                averageSpan.textContent = formattedRating;
              }
            }
          }
        });
      } catch (error) {}
    }

    function formatReviewTimestamps() {
      try {
        const turkishMonths = [
          'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
          'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
        ];
        
        const timestamps = document.querySelectorAll('.jdgm-rev__timestamp[data-content]');
        timestamps.forEach(timestamp => {
          const utcDateString = timestamp.getAttribute('data-content');
          if (utcDateString && !timestamp.hasAttribute('data-formatted')) {
            try {
              const utcDate = new Date(utcDateString.replace(' UTC', 'Z'));
              
              const istanbulDate = new Date(utcDate.toLocaleString("en-US", {timeZone: "Europe/Istanbul"}));
              
              const day = istanbulDate.getDate();
              const monthIndex = istanbulDate.getMonth();
              const year = istanbulDate.getFullYear();
              
              const turkishDate = `${day} ${turkishMonths[monthIndex]} ${year}`;
              
              timestamp.textContent = turkishDate;
              timestamp.setAttribute('data-formatted', 'true');
              
              const reviewContainer = timestamp.closest('.jdgm-rev');
              if (reviewContainer) {
                const isQuestion = reviewContainer.querySelector('.jdgm-quest__asker');
                const authorWrapper = reviewContainer.querySelector('.jdgm-rev__author-wrapper');
                
                if (authorWrapper && !authorWrapper.contains(timestamp)) {
                  authorWrapper.appendChild(timestamp);
                }
              }
              
            } catch (dateError) {
            }
          }
        });
        
        const allTimestamps = document.querySelectorAll('.jdgm-rev__timestamp');
        allTimestamps.forEach(timestamp => {
          const text = timestamp.textContent.trim();
          
          const mmddyyyyPattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
          const match = text.match(mmddyyyyPattern);
          
          if (match) {
            const month = parseInt(match[1]) - 1; // 0 tabanlı ay indexi
            const day = parseInt(match[2]);
            const year = parseInt(match[3]);
            
            if (month >= 0 && month < 12) {
              const turkishDate = `${day} ${turkishMonths[month]} ${year}`;
              timestamp.textContent = turkishDate;
              timestamp.setAttribute('data-formatted', 'true');
            }
          }
        });
        
        const reviewContainers = document.querySelectorAll('.jdgm-rev');
        reviewContainers.forEach(container => {
          const timestampElements = container.querySelectorAll('*');
          timestampElements.forEach(element => {
            if (element.childNodes) {
              element.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                  const text = node.textContent.trim();
                  const mmddyyyyPattern = /(\d{1,2})\/(\d{1,2})\/(\d{4})/g;
                  
                  const updatedText = text.replace(mmddyyyyPattern, (match, month, day, year) => {
                    const monthIndex = parseInt(month) - 1;
                    if (monthIndex >= 0 && monthIndex < 12) {
                      return `${parseInt(day)} ${turkishMonths[monthIndex]} ${year}`;
                    }
                    return match;
                  });
                  
                  if (updatedText !== text) {
                    node.textContent = updatedText;
                  }
                }
              });
            }
          });
        });
        
      } catch (error) {}
    }

    function forceAllDateFormats() {
      try {
        const turkishMonths = [
          'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
          'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
        ];
        
        const walker = document.createTreeWalker(
          document.body,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );
        
        const textNodes = [];
        let node;
        while (node = walker.nextNode()) {
          textNodes.push(node);
        }
        
        textNodes.forEach(textNode => {
          const text = textNode.textContent;
          const mmddyyyyPattern = /(\d{1,2})\/(\d{1,2})\/(\d{4})/g;
          
          const updatedText = text.replace(mmddyyyyPattern, (match, month, day, year) => {
            const monthIndex = parseInt(month) - 1;
            if (monthIndex >= 0 && monthIndex < 12) {
              return `${parseInt(day)} ${turkishMonths[monthIndex]} ${year}`;
            }
            return match;
          });
          
          if (updatedText !== text) {
            textNode.textContent = updatedText;
          }
        });
        
      } catch (error) {
        console.log('forceAllDateFormats hatası:', error);
      }
    }

    function hideUnwantedElements() {
      try {
        const spinners = document.querySelectorAll('.jdgm-spinner');
        spinners.forEach(spinner => {
          spinner.style.display = 'none';
        });

        const allElements = document.querySelectorAll('*');
        allElements.forEach(element => {
          try {
            if (element.textContent && (
                element.textContent.includes('Verilerinizi nasıl kullanıyoruz'))) {
              
              const childElements = element.querySelectorAll('*');
              const hasJudgeContent = childElements.length === 0 || 
                                    !Array.from(childElements).some(child => 
                                      child.textContent && !child.textContent.includes('Judge.me') && 
                                      !child.textContent.includes('Verilerinizi') &&
                                      !child.textContent.includes('şartlar') &&
                                      !child.textContent.includes('gizlilik') &&
                                      !child.textContent.includes('politika')
                                    );
              
              if (hasJudgeContent) {
                element.style.cssText = 'display: none !important; opacity: 0 !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important;';
              }
            }
          } catch (e) {}
        });

        const privacySelectors = [
          '.jdgm-form__disclaimer',
          '.jdgm-form__privacy',
          '.jdgm-disclaimer',
          '.jdgm-privacy',
          '[class*="jdgm"][class*="privacy"]',
          '[class*="jdgm"][class*="disclaimer"]',
          '[class*="jdgm"] small',
          '[class*="jdgm"] .small',
          '[class*="jdgm"] .text-muted',
          '[class*="jdgm"] .disclaimer'
        ];

        privacySelectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(element => {
            try {
              if (element.textContent && (
                  element.textContent.includes('Verilerinizi') || 
                  element.textContent.includes('Judge.me') || 
                  element.textContent.includes('şartlar') ||
                  element.textContent.includes('gizlilik') ||
                  element.textContent.includes('politika'))) {
                element.style.cssText = 'display: none !important; opacity: 0 !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important;';
              }
            } catch (e) {}
          });
        });

        const cancelButtons = document.querySelectorAll('a[class*="jdgm-cancel"], button[class*="jdgm-cancel"]');
        cancelButtons.forEach(btn => {
          try {
            btn.style.display = 'none';
          } catch (e) {}
        });

        const nameFormatContainers = document.querySelectorAll('.jdgm-form__reviewer-name-format-container');
        nameFormatContainers.forEach(container => {
          try {
            container.style.display = 'none';
          } catch (e) {}
        });

        const privacyFieldsets = document.querySelectorAll('.jdgm-form__fieldset');
        privacyFieldsets.forEach(fieldset => {
          try {
            const pTag = fieldset.querySelector('p');
            if (pTag && pTag.textContent && (
                pTag.textContent.includes('Verilerinizi nasıl kullanıyoruz') ||
                pTag.textContent.includes('Judge.me') ||
                pTag.textContent.includes('şartlar') ||
                pTag.textContent.includes('gizlilik') ||
                pTag.textContent.includes('politika') ||
                pTag.textContent.includes('Değerlendirmenizi göndererek') ||
                pTag.textContent.includes('kabul etmiş olursunuz'))) {
              fieldset.style.cssText = 'display: none !important; opacity: 0 !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important;';
            }
          } catch (e) {}
        });

        const privacyParagraphs = document.querySelectorAll('p');
        privacyParagraphs.forEach(p => {
          try {
            if (p.textContent && (
                p.textContent.includes('Verilerinizi nasıl kullanıyoruz') ||
                p.textContent.includes('Judge.me') ||
                p.textContent.includes('şartlar') ||
                p.textContent.includes('gizlilik') ||
                p.textContent.includes('politika') ||
                p.textContent.includes('Değerlendirmenizi göndererek') ||
                p.textContent.includes('kabul etmiş olursunuz'))) 
            {
              p.style.cssText = 'display: none !important; opacity: 0 !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important;';
            }
            if(p.textContent && p.textContent.includes('Abone olarak')){
              p.style.cssText = '';
            }
          } catch (e) {}
        });

      } catch (error) {}
    }


    function addImageUploadToggle() {
      try {
        const judgeForms = document.querySelectorAll('.jdgm-form, .jdgm-question-form');
        
        judgeForms.forEach(form => {
          if (form.hasAttribute('data-upload-toggle-added')) return;
          form.setAttribute('data-upload-toggle-added', 'true');
          
          const mediaFieldset = form.querySelector('.jdgm-form__fieldset:has(.jdgm-media-fieldset__container), .jdgm-form__fieldset:has(.jdgm-media-fieldset__input)');
          if (!mediaFieldset) return;
          
          mediaFieldset.style.cssText = `
            display: none !important;
            opacity: 0 !important;
            visibility: hidden !important;
            transition: all 0.3s ease !important;
          `;
          
          const textareaFieldset = form.querySelector('.jdgm-form__fieldset:has(textarea[name="review_body"]), .jdgm-form__fieldset:has(textarea[name="question_content"])');
          if (!textareaFieldset) return;
          
          const shareButton = form.querySelector('.jdgm-btn, button[type="submit"], input[type="submit"]');
          if (shareButton) {
            shareButton.style.cssText = `
              background-color: #738F8F !important;
              color: white !important;
              border: 1px solid #738F8F !important;
              border-radius: 0px !important;
              font-weight: normal !important;
              box-shadow: none !important;
              text-shadow: none !important;
              transition: all 0.3s ease !important;
            `;
          }
          
          const switchContainer = document.createElement('div');
          switchContainer.className = 'jdgm-upload-switch-container';
          switchContainer.style.cssText = `
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            margin-top: 1.5rem !important;
            margin-bottom: 1rem !important;
            padding: 0 !important;
          `;
          
          const switchLabel = document.createElement('label');
          switchLabel.textContent = getLocaleText('upload_image');
          switchLabel.style.cssText = `
            font-size: 1.4rem !important;
            color: #374151 !important;
            font-weight: normal !important;
            margin: 0 !important;
            cursor: pointer !important;
          `;
          
          const switchWrapper = document.createElement('div');
          switchWrapper.className = 'jdgm-switch-wrapper';
          switchWrapper.style.cssText = `
            position: relative !important;
            width: 4.4rem !important;
            height: 2.4rem !important;
            background-color: #d1d5db !important;
            border-radius: 1.2rem !important;
            cursor: pointer !important;
            transition: background-color 0.3s ease !important;
            border: none !important;
            outline: none !important;
          `;
          
          const switchKnob = document.createElement('div');
          switchKnob.className = 'jdgm-switch-knob';
          switchKnob.style.cssText = `
            position: absolute !important;
            top: 0.2rem !important;
            left: 0.2rem !important;
            width: 2rem !important;
            height: 2rem !important;
            background-color: white !important;
            border-radius: 50% !important;
            transition: transform 0.3s ease !important;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
          `;
          
          switchWrapper.appendChild(switchKnob);
          
          let isMediaVisible = false;
          
          function toggleSwitch() {
            if (isMediaVisible) {
              mediaFieldset.style.cssText = `
                display: none !important;
                opacity: 0 !important;
                visibility: hidden !important;
                transition: all 0.3s ease !important;
              `;
              
              switchWrapper.style.backgroundColor = '#d1d5db';
              switchKnob.style.transform = 'translateX(0)';
              
              isMediaVisible = false;
            } else {
              mediaFieldset.style.cssText = `
                display: block !important;
                opacity: 1 !important;
                visibility: visible !important;
                transition: all 0.3s ease !important;
              `;
              
              switchWrapper.style.backgroundColor = '#72888F';
              switchKnob.style.transform = 'translateX(2rem)';
              
              isMediaVisible = true;
            }
          }
          
          switchWrapper.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            toggleSwitch();
          });
          
          switchLabel.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            toggleSwitch();
          });
          
          switchWrapper.addEventListener('mouseenter', function() {
            if (!isMediaVisible) {
              this.style.backgroundColor = '#9ca3af';
            }
          });
          
          switchWrapper.addEventListener('mouseleave', function() {
            if (!isMediaVisible) {
              this.style.backgroundColor = '#d1d5db';
            }
          });
          
          switchContainer.appendChild(switchLabel);
          switchContainer.appendChild(switchWrapper);
          
          textareaFieldset.parentNode.insertBefore(switchContainer, textareaFieldset.nextSibling);
        });
        
      } catch (error) {}
    }

    function enhancePopupStyling() {
      try {
        const popupForms = document.querySelectorAll('.jdgm-form');
        
        popupForms.forEach(form => {
          const computedStyle = window.getComputedStyle(form);
          const isPopup = computedStyle.position === 'fixed' || 
                         form.style.position === 'fixed' ||
                         form.getAttribute('style')?.includes('position: fixed') ||
                         form.getAttribute('style')?.includes('position:fixed');
          
          if (isPopup) {
            form.style.setProperty('background-color', '#f8f9fa', 'important');
            form.style.setProperty('border', '1px solid #e9ecef', 'important');
            form.style.setProperty('border-radius', '12px', 'important');
            form.style.setProperty('box-shadow', '0 10px 40px rgba(0, 0, 0, 0.15)', 'important');
            form.style.setProperty('padding', '2.4rem', 'important');
            form.style.setProperty('max-width', '600px', 'important');
            
            const inputs = form.querySelectorAll('input, textarea, select');
            inputs.forEach(input => {
              input.style.setProperty('border', '1px solid #d1d5db', 'important');
              input.style.setProperty('border-radius', '8px', 'important');
              input.style.setProperty('padding', '1.2rem 1.6rem', 'important');
              input.style.setProperty('background-color', '#ffffff', 'important');
              input.style.setProperty('color', '#374151', 'important');
            });
            
            const buttons = form.querySelectorAll('.jdgm-btn');
            buttons.forEach(btn => {
              btn.style.setProperty('border-radius', '0px', 'important');
              btn.style.setProperty('padding', '1.2rem 2rem', 'important');
            });
            
            const title = form.querySelector('.jdgm-form__title');
            if (title) {
              title.style.setProperty('color', '#111827', 'important');
              title.style.setProperty('border-bottom', '1px solid #e9ecef', 'important');
            }
            
            const overlay = document.querySelector('.fixed-overlay');
            if (overlay) {
              overlay.style.setProperty('background-color', 'rgba(0, 0, 0, 0.5)', 'important');
              overlay.style.setProperty('backdrop-filter', 'blur(3px)', 'important');
            }
          }
        });
        
        const reviewModals = document.querySelectorAll('.jdgm-write-review-modal__content');
        reviewModals.forEach(modal => {
          if (!modal.hasAttribute('data-styled')) {
            modal.setAttribute('data-styled', 'true');
            
            const overlay = modal.closest('[style*="position: fixed"]') || 
                           modal.closest('.jdgm-modal') ||
                           document.querySelector('.jdgm-write-review-modal');
            
            if (overlay && !overlay.hasAttribute('data-overlay-styled')) {
              overlay.setAttribute('data-overlay-styled', 'true');
              overlay.style.setProperty('background-color', 'rgba(0, 0, 0, 0.5)', 'important');
              overlay.style.setProperty('backdrop-filter', 'blur(3px)', 'important');
            }
          }
        });
        
      } catch (error) {}
    }

    function addCloseButton() {
      try {
        const orphanedButtons = document.querySelectorAll('.jdgm-custom-close-btn');
        orphanedButtons.forEach(btn => {
          const parentModal = btn.closest('[class*="jdgm-write-review-modal"], [class*="jdgm"][style*="position: fixed"]');
          if (!parentModal || window.getComputedStyle(parentModal).display === 'none') {
            btn.remove();
          }
        });
        
        const modalElements = [];
        const reviewPopups = document.querySelectorAll(`
          .jdgm-write-review-modal,
          .jdgm-write-review-modal__content,
          [class*="jdgm"][style*="position: fixed"],
          [class*="jdgm-modal"],
          [class*="jdgm-popup"]
        `);
        
        reviewPopups.forEach(element => {
          if (element.hasAttribute('data-close-added')) return;
          
          const computedStyle = window.getComputedStyle(element);
          const rect = element.getBoundingClientRect();
          
          const minWidth = isMobile() ? 280 : 400;
          const minHeight = isMobile() ? 200 : 300;
          
          const isReviewPopup = (
            (computedStyle.position === 'fixed' || element.style.position === 'fixed') &&
            computedStyle.display !== 'none' &&
            computedStyle.visibility !== 'hidden' &&
            rect.width > minWidth && rect.height > minHeight &&
            (
              element.querySelector('form, textarea, input[type="text"]') ||
              element.textContent.toLowerCase().includes('değerlendirm') ||
              element.textContent.toLowerCase().includes('review') ||
              element.textContent.toLowerCase().includes('yorum')
            )
          );
          
          if (isReviewPopup) {
            modalElements.push(element);
          }
        });
        
        modalElements.forEach(modal => {
          const existingCustomButtons = modal.querySelectorAll('.jdgm-custom-close-btn');
          existingCustomButtons.forEach(btn => btn.remove());
          
          modal.setAttribute('data-close-added', 'true');
          
          const closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.className = 'jdgm-custom-close-btn';
          closeBtn.innerHTML = '×';
          closeBtn.setAttribute('aria-label', getLocaleText('accessibility.close'));
          closeBtn.setAttribute('data-modal-id', modal.className || 'modal');
          
          const buttonSize = isMobile() ? '40px' : '32px';
          const buttonTop = isMobile() ? '8px' : '10px';
          const buttonRight = isMobile() ? '8px' : '10px';
          const fontSize = isMobile() ? '22px' : '18px';
          
          closeBtn.style.cssText = `
            position: absolute !important;
            top: ${buttonTop} !important;
            right: ${buttonRight} !important;
            width: ${buttonSize} !important;
            height: ${buttonSize} !important;
            background: #ffffff !important;
            border: 2px solid #d1d5db !important;
            font-size: ${fontSize} !important;
            color: #374151 !important;
            cursor: pointer !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            border-radius: 50% !important;
            transition: all 0.2s ease !important;
            z-index: 999999 !important;
            line-height: 1 !important;
            padding: 0 !important;
            margin: 0 !important;
            font-family: Arial, sans-serif !important;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
            font-weight: bold !important;
            min-width: ${buttonSize} !important;
            min-height: ${buttonSize} !important;
            opacity: 1 !important;
            visibility: visible !important;
            touch-action: manipulation !important;
            -webkit-tap-highlight-color: transparent !important;
            -webkit-user-select: none !important;
            user-select: none !important;
          `;
          
          let touchStartTime = 0;
          let isPressed = false;
          
          const applyActiveStyle = () => {
            closeBtn.style.backgroundColor = '#f8f9fa';
            closeBtn.style.borderColor = '#000000';
            closeBtn.style.color = '#000000';
            closeBtn.style.transform = 'scale(1.1)';
            closeBtn.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.3)';
          };
          
          const removeActiveStyle = () => {
            closeBtn.style.backgroundColor = '#ffffff';
            closeBtn.style.borderColor = '#d1d5db';
            closeBtn.style.color = '#374151';
            closeBtn.style.transform = 'scale(1)';
            closeBtn.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
          };
          
          if (!isMobile()) {
            closeBtn.addEventListener('mouseenter', applyActiveStyle);
            closeBtn.addEventListener('mouseleave', removeActiveStyle);
          }
          
          closeBtn.addEventListener('touchstart', function(e) {
            e.preventDefault();
            e.stopPropagation();
            touchStartTime = Date.now();
            isPressed = true;
            applyActiveStyle();
          }, { passive: false });
          
          closeBtn.addEventListener('touchmove', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const touch = e.touches[0];
            const rect = closeBtn.getBoundingClientRect();
            const isOutside = (
              touch.clientX < rect.left || 
              touch.clientX > rect.right || 
              touch.clientY < rect.top || 
              touch.clientY > rect.bottom
            );
            
            if (isOutside && isPressed) {
              isPressed = false;
              removeActiveStyle();
            }
          }, { passive: false });
          
          closeBtn.addEventListener('touchend', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const touchDuration = Date.now() - touchStartTime;
            
            if (isPressed && touchDuration < 500) {
              setTimeout(() => {
                closeModal();
              }, 100); k
            }
            
            isPressed = false;
            removeActiveStyle();
          }, { passive: false });
          
          closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            closeModal();
          });
          
          const closeModal = () => {
            
            try {
              const existingCloseBtn = modal.querySelector('.jdgm-close, .jdgm-close-btn, .jdgm-write-review-modal__close-btn') ||
                                     document.querySelector('.jdgm-write-review-modal__close-btn, .jdgm-close, .jdgm-close-btn');
              
              if (existingCloseBtn && existingCloseBtn !== closeBtn) {
                existingCloseBtn.click();
              }
              
              if (modal) {
                modal.style.setProperty('display', 'none', 'important');
                modal.style.setProperty('visibility', 'hidden', 'important');
                modal.style.setProperty('opacity', '0', 'important');
                
                const modalContainer = modal.closest('[style*="position: fixed"]');
                if (modalContainer && modalContainer !== modal) {
                  modalContainer.style.setProperty('display', 'none', 'important');
                }
                
                const overlay = document.querySelector('.jdgm-write-review-modal, [class*="jdgm-overlay"], [class*="jdgm-backdrop"]');
                if (overlay) {
                  overlay.style.setProperty('display', 'none', 'important');
                }
                
                modal.removeAttribute('data-close-added');
              }
              
              document.dispatchEvent(new KeyboardEvent('keydown', {
                key: 'Escape',
                keyCode: 27,
                which: 27,
                bubbles: true
              }));
              
              setTimeout(() => {
                window.location.reload();
              }, 300);
              
            } catch (error) {
              window.location.reload();
            }
          };
          
          const modalStyle = window.getComputedStyle(modal);
          if (modalStyle.position === 'static') {
            modal.style.position = 'relative';
          }
          
          modal.style.overflow = 'visible';
          
          let contentArea = modal.querySelector('.jdgm-write-review-modal__content, .jdgm-modal-content, .jdgm-content') || modal;
          
          if (contentArea !== modal) {
            const contentStyle = window.getComputedStyle(contentArea);
            if (contentStyle.position === 'static') {
              contentArea.style.position = 'relative';
            }
          }
          
          if (contentArea.firstChild) {
            contentArea.insertBefore(closeBtn, contentArea.firstChild);
          } else {
            contentArea.appendChild(closeBtn);
          }
        });
        
        const defaultCloseButtons = document.querySelectorAll(`
          .jdgm-write-review-modal__close-btn:not(.jdgm-custom-close-btn),
          .jdgm-close:not(.jdgm-custom-close-btn),
          .jdgm-close-btn:not(.jdgm-custom-close-btn),
          .jdgm-modal-close:not(.jdgm-custom-close-btn)
        `);
        
        defaultCloseButtons.forEach(btn => {
          if (!btn.classList.contains('jdgm-custom-close-btn')) {
            btn.style.setProperty('display', 'none', 'important');
            btn.style.setProperty('visibility', 'hidden', 'important');
            btn.style.setProperty('opacity', '0', 'important');
            btn.style.setProperty('pointer-events', 'none', 'important');
          }
        });
        
      } catch (error) {}
    }

    function replaceTemplateTexts() {
      try {
        const elements = document.querySelectorAll('*');
        elements.forEach(element => {
          if (element.textContent && element.textContent.includes('{{')) {
          }
        });
      } catch (error) {}
    }

    function styleBasicElements() {
      try {
        const judgeElements = document.querySelectorAll('[class*="jdgm"]');
        judgeElements.forEach(element => {
          if (element.classList.contains('jdgm-btn')) {
            element.style.borderRadius = '0px';
            element.style.transition = 'all 0.3s ease';
          }
        });
      } catch (error) {}
    }

    function isProductPage() {
      return window.location.pathname.includes('/products/');
    }

    function removeCustomerReviewsTitleFromProductPage() {
      if (!isProductPage()) return;
      try {
        const reviewSections = document.querySelectorAll('.section.section-rich-text');
        
        reviewSections.forEach(section => {
          const heading = section.querySelector('.rich-text__heading');
          if (heading && heading.textContent.trim() === 'Müşteri Yorumları') {
            section.remove();
          }
        });
    
    
      } catch (error) {}
    }
    replaceTextContent();
    replaceTemplateTexts();
    replaceReviewCountTexts();
    updateRealAverage();
    formatReviewTimestamps();
    forceAllDateFormats();
    styleBasicElements();
    addImageUploadToggle();
    addCloseButton();
    removeCustomerReviewsTitleFromProductPage();

    const delayedInit = debounce(() => {
      replaceReviewCountTexts();
      updateRealAverage();
      formatReviewTimestamps();
      forceAllDateFormats();
      styleBasicElements();
      addImageUploadToggle();
      enhancePopupStyling();
      addCloseButton();
      removeCustomerReviewsTitleFromProductPage();
    }, 200);

    setTimeout(delayedInit, 500);
    setTimeout(delayedInit, 1000);
    setTimeout(delayedInit, 2000);
    setTimeout(delayedInit, 3000);
    setTimeout(delayedInit, 5000);
    

    document.addEventListener('click', function(e) {
      const target = e.target;
      const isWriteReviewButton = target.classList && (
        target.classList.contains('jdgm-write-rev-link') ||
        target.classList.contains('jdgm-write-review') ||
        (target.textContent && target.textContent.includes(getLocaleText('write_review')))
      );
      
      if (isWriteReviewButton) {
        setTimeout(() => addCloseButton(), 300);
        setTimeout(() => addCloseButton(), 800);
        setTimeout(() => addCloseButton(), 1500);
      }
    });

    const observer = new MutationObserver(debounce(function(mutations) {
      let shouldCheckCloseButton = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          replaceTextContent();
          replaceTemplateTexts();
          replaceReviewCountTexts(); // Add review count replacement
          updateRealAverage(); // Update real average from aria-label
          formatReviewTimestamps(); // Format review timestamps
          forceAllDateFormats();
          hideUnwantedElements();
          styleBasicElements();
          addImageUploadToggle();
          enhancePopupStyling();
          removeCustomerReviewsTitleFromProductPage();
          
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.classList && 
                (node.classList.contains('jdgm-modal') || 
                 node.classList.contains('jdgm-write-review-modal') ||
                 (node.style && node.style.position === 'fixed'))) {
              shouldCheckCloseButton = true;
            }
          });
        }
      });
      
      if (shouldCheckCloseButton) {
        setTimeout(() => addCloseButton(), 200);
        setTimeout(() => addCloseButton(), 600);
      }
    }, 100));

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    if (isMobile()) {
      
      setTimeout(() => addCloseButton(), 1500);
      setTimeout(() => addCloseButton(), 3000);
      
      window.addEventListener('orientationchange', function() {
        setTimeout(() => {
          addCloseButton();
        }, 500);
      });
      
      window.addEventListener('resize', debounce(() => {
        addCloseButton();
      }, 200));
    }
  } catch (error) {}
});   

    function updateStarSummaryFormat() {
      document.querySelectorAll('.jdgm-rev-widg__summary, .jdgm-all-reviews__summary').forEach(function(summary) {
        if (summary.querySelector('.custom-star-summary')) return;

        var ratingSpan = summary.querySelector('.jdgm-rev-widg__summary-average, .jdgm-all-reviews__summary-average');
        var rating = ratingSpan ? ratingSpan.textContent.trim().replace(',', '.') : null;

        var countSpan = summary.querySelector('.jdgm-rev-widg__summary-text, .jdgm-all-reviews__summary-text');
        var count = 0;
        if (countSpan) {
          var match = countSpan.textContent.match(/(\d+)/);
          if (match) count = parseInt(match[1], 10);
        }

        var label = 'Değerlendirme';

        if (countSpan) countSpan.style.display = 'none';

        if (rating) {
          var custom = document.createElement('span');
          custom.className = 'custom-star-summary';
          custom.style.marginLeft = '0.5em';
          custom.textContent = rating + ' | ' + count + ' ' + label;
          ratingSpan.parentNode.appendChild(custom);
        }
      });
    }
    document.addEventListener('DOMContentLoaded', updateStarSummaryFormat);
    if (window.MutationObserver) {
      var observerStarSummary = new MutationObserver(updateStarSummaryFormat);
      observerStarSummary.observe(document.body, { childList: true, subtree: true });
    }   

    function updatePreviewBadgeFormat() {
      document.querySelectorAll('.jdgm-widget.jdgm-preview-badge').forEach(function(widget) {
        if (widget.querySelector('.custom-star-summary')) return;

        var badge = widget.querySelector('.jdgm-prev-badge');
        if (!badge) return;

        var stars = badge.querySelector('.jdgm-prev-badge__stars');
        var score = stars ? stars.getAttribute('data-score') : null;

        var textSpan = badge.querySelector('.jdgm-prev-badge__text');
        var count = 0;
        if (textSpan) {
          var match = textSpan.textContent.match(/(\d+)/);
          if (match) count = parseInt(match[1], 10);
          textSpan.style.display = 'none'; // Eski metni gizle
        }

        var qaBadge = badge.querySelector('.jdgm-qa-badge');
        if (qaBadge) qaBadge.style.display = 'none';

        if (stars && score) {
          var custom = document.createElement('span');
          custom.className = 'custom-star-summary';
          custom.style.marginLeft = '0.5em';
          var scoreDisplay = score.replace('.', ',');
          custom.textContent = scoreDisplay + ' | ' + count + ' Değerlendirme';
          stars.parentNode.insertBefore(custom, stars.nextSibling);
        }
      });
    }
    document.addEventListener('DOMContentLoaded', updatePreviewBadgeFormat);
    if (window.MutationObserver) {
      var observerPreviewBadge = new MutationObserver(updatePreviewBadgeFormat);
      observerPreviewBadge.observe(document.body, { childList: true, subtree: true });
    }   